import React, { useState } from 'react'

import Hiring from '../../../../../presentation/pages/doctors/hiring'

import { useFetchContracts } from '../../../../../presentation/hooks/fetch-contracts'
import { useMe } from '../../../../../presentation/contexts/me'

import { makeDoctorsContracts } from '../../../../usecases/contracts/remote-contracts-factory'

import IContractedContractor from '../../../../../presentation/interfaces/contracted-contractor'
import useFetchConversations from '../../../../../presentation/hooks/fetch-conversations'

const MakeHiring = () => {
  document.title = 'BuscarMédicos - Contratações'

  const [available, setAvailable] = useState(true)

  const { me } = useMe()

  const { contracts } = useFetchContracts<IContractedContractor>(
    makeDoctorsContracts(me?.id as number),
  )

  const conversations = useFetchConversations(me?.id)

  const handleSwitch = () => {
    setAvailable(!available)
  }

  const contractsToRender = contracts.map((contractor) => ({
    ...contractor,
    hasNewMessage: conversations.some(
      (conversation) => conversation.id === String(contractor.contractorId)
        && conversation.messages.some(
          (message) => !message.isRead && message.receiverId === String(me?.id),
        ),
    ),
  }))

  return (
    <Hiring
      tableDataAll={contractsToRender}
      setAvailable={handleSwitch}
      available={available}
    />
  )
}

export default MakeHiring
